import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';
import LoadingSpinner from '../frontend/LoadingSpinner';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

import plus_icon_black from '../../assets/frontend/images/plus_icon_black.png';
import edit_icon from '../../assets/frontend/images/edit_icon.png';
import delete_icon from '../../assets/frontend/images/delete_icon.png';

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

function Home() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);

    const [authRole, setAuthRole] = useState(
        AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
    );

	const [viewMode, setViewMode] = useState('view_create'); // 'view_account' | 'save_user' | 'change_password' | 'save_organization'

	const initialUserInput = {
		first_name: '',
		last_name: '',
		email: '',
		app: process.env.REACT_APP_NAME,
		errorList: [],
		errorStyle: [],
	};
	const [userInput, setUserInput] = useState(initialUserInput);

	// Initial call for user list items
	useEffect(() => {

		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData()
			navHistory('/');
		}

		if (isMounted) {
			console.log('[Home - useEffect] mounted');

			setViewMode('view_create');
		} else {
			setIsMounted(true);
		}

	}, [isMounted]);

	// X FUNCTIONS
	const handleOpenXForm = () => {
		/*
		const tempUserInput = {
			first_name: localStorage.getItem('auth_first_name'),
			last_name: localStorage.getItem('auth_last_name'),
			email: localStorage.getItem('auth_email'),
			app: process.env.REACT_APP_NAME,
			errorList: [],
			errorStyle: [],
		};

		setUserInput(tempUserInput);
		setViewMode('save_X');
		*/
	};
	function handleCloseXForm() {
		// Merge backend org with defaults, so errorList & errorStyle exist
		/*
		setUserInput({...initialUserInput});
		setViewMode('view_account');
		*/
	}
	const handleXInput = (event) => {
		event.persist();
		/*
		setUserInput({ ...userInput, [event.target.name]: event.target.value });
		
		console.log('User Input: ',event.target.name, event.target.value);
		
		//remove the target error message no matter the new input, it will be validated on the server
		if (userInput.errorList.hasOwnProperty(event.target.name)) {
		delete userInput.errorList[event.target.name];
		delete userInput.errorStyle[event.target.name];
		$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
		*/
	}

	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell">
						<span className="font-orbitron font-weight-800 font-size-24l-20m-18s letter-spacing-0px uppercase italic">Home</span>
					</div>
				</div>
			</div>

			{viewMode === 'view_create' && (
				<div className="panel large pt-20l-10s">
					<div className="grid-x bg-fafafa b1-ccc p-20l-10s">

						<div className="large-6 medium-6 small-6 cell text-left">
							<div className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic underline">User</div>
						</div>

						<div className="large-6 medium-6 small-6 cell text-right">
							<Link onClick={handleOpenXForm} className="button icon"><img src={edit_icon} alt="Edit User" /></Link>
						</div>

						<div className="large-12 medium-12 small-12 cell text-left pt-10">
							<table className="unstriped unbordered mb-0">
								<tbody>
									<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Name:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_first_name') + ' ' + localStorage.getItem('auth_last_name')}</td></tr>
									<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Email:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_email')}</td></tr>
									<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Role:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_role')}</td></tr>
									<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Password:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">
										********
									</td></tr>
									<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px">Paypal Email:</td><td className="font-poppins font-size-18l-16m font-weight-600">{localStorage.getItem('auth_paypal_email')}</td></tr>
								</tbody>
							</table>
						</div>

					</div>
				</div>
			)}
			{viewMode === 'save_user' && (
				<>
					<div className="panel large pt-20l-10s">
						<div className="grid-x bb1-555 pb-5">
							<div className="large-12 medium-12 small-12 cell">
								<span className="font-orbitron font-size-24 font-weight-800 uppercase italic">Profile</span>
							</div>
						</div>
					</div>
					<div className="panel large pt-20l-10s">
						<div className="grid-x">
							<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-10 ">
							</div>
						</div>
					</div>
				</>
			)}

		</div>
	);
}

export default Home;